import config from '../services/config';

export const getHubAction = (actionType) => {
	return `@@HUB/${actionType}`;
}

export const getPayloadWithAllowedQueryParams = params => {
  let payload = {}
  const { can_create=false } = params || {};
  const ALLOWED_QUERY_PARAMS = config.get('ALLOWED_QUERY_PARAMS');
  if (can_create && ALLOWED_QUERY_PARAMS) {
    payload = {
      ...ALLOWED_QUERY_PARAMS,
    }
  }
  payload = {
    ...payload,
    ...params,
  }
  return payload;
}